// src/components/EmailThread/PreviewModal.jsx
import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadFile, handlePdfDownload } from "../../utils/utils";

const PreviewModal = ({ isModalOpen, onClose, previewFile, darkMode, id }) => {
    const [errorMessageShown, setErrorMessageShown] = useState(false);
    if (!previewFile) return null;
   
    const fileName = previewFile.split("/").pop();
    const handleDownload = () => {
        if (previewFile.toLowerCase().endsWith(".docx")) {
            downloadFile(previewFile, fileName);
        } else if (previewFile.toLowerCase().endsWith(".pdf")) {
            handlePdfDownload(previewFile, errorMessageShown, setErrorMessageShown);
        } else {
            message.error("This file type is not supported for download.");
        }
    };

    return (
        <Modal
            open={isModalOpen}
            onCancel={onClose}
            width="90%"
            height="80%"
            footer={null}
            destroyOnClose={true}
            closeIcon={
                <div className="flex items-center justify-center bg-red-600 rounded-[50%] w-[42px] h-[22px] "
                    // style={{
                    //     backgroundColor: "red",
                    //     borderRadius: "50%",
                    //     width: 42,
                    //     height: 22,
                    //     display: "flex",
                    //     alignItems: "center",
                    //     justifyContent: "center",
                    // }}
                >
                    <span style={{ color: "#fff", fontSize: 14 }}>✕</span>
                </div>
            }
        >
            <div style={{ position: "relative", height: "calc(100vh - 100px)" }}>
                {/* Download Button */}
                <div style={{ position: "absolute", top: 10, left: 10, zIndex: 10 }}>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={handleDownload}
                    >
                        Download
                    </Button>
                </div>

                {/* File Preview */}
                {previewFile.toLowerCase().endsWith(".docx") ? (
                    <iframe
                        src={`/edit-document/${id}?agreementFile=${encodeURIComponent(
                            previewFile
                        )}&t=${Date.now()}&editable=false`}
                        width="100%"
                        height="100%"
                        style={{
                            border: "none",
                            backgroundColor: darkMode ? "#17153B" : "#fff",
                        }}
                    />
                ) : previewFile.toLowerCase().endsWith(".pdf") ? (
                    <iframe
                        src={previewFile}
                        width="100%"
                        height="100%"
                        style={{
                            border: "none",
                            backgroundColor: darkMode ? "#17153B" : "#fff",
                        }}
                    />
                ) : (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#999",
                        }}
                    >
                        Preview not available
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default PreviewModal;
